module.exports = __webpack_public_path__ + "img/08.09c08cfc.svg";